import axios from 'axios'
export default {
  API: axios.create({
    baseURL: 'https://api.kampalabiennale.org',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
    }
  }), 
  headers: {
    'X-CSRF-Token': 'r536T32DoilGo0YmrQMm60i1dZli3I7GBQ4oEv7NUec',
    'Authorization': 'Basic aXNhYWM6YWJva2lzYWFj'
  }
}